module.exports = __webpack_public_path__ + "static/media/display-3.4ad1823d.png";